export enum SiteSlugEnum {
  NeomOxagon = 'neom-oxagon', // neom-order-admin
  NeomHospital = 'neomhospital' // neomhospital-order-admin
}
